import type { FC } from 'react';
import { Avatar, Box, ButtonBase } from '@mui/material';
import { useAuth } from 'src/hooks/use-auth';
import { usePopover } from 'src/hooks/use-popover';
import { AccountPopover } from './account-popover';

export const AccountButton: FC = () => {
  const { user } = useAuth();
  const popover = usePopover<HTMLButtonElement>();

  // Get the first letter of the email and capitalize it
  const getInitial = () => {
    if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return 'U'; // Default if no email
  };

  return (
    <>
      <Box
        component={ButtonBase}
        onClick={popover.handleOpen}
        ref={popover.anchorRef}
        sx={{
          alignItems: 'center',
          display: 'flex',
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: 'divider',
          height: 40,
          width: 40,
          borderRadius: '50%'
        }}
      >
        <Avatar
          sx={{
            height: 32,
            width: 32,
            bgcolor: 'primary.main' // Use a primary color background
          }}
        >
          {getInitial()}
        </Avatar>
      </Box>
      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
